import { useState } from 'react';
import { Alert, Select, Spin } from '@ssar-app/uikit';
import { Button, HStack, Input, Text, VStack } from '@chakra-ui/react';

interface ClientSelectionProps {
  isLoading?: boolean;
  subscriberCodes: string[];
  errorMsg?: string;
  onClick?: (val: string) => void;
  showModal?: boolean;
}

export const ClientSelectorModal = (props: ClientSelectionProps) => {
  const {
    isLoading = false,
    subscriberCodes = [],
    errorMsg = '',
    onClick,
    showModal = true,
  } = props;
  const [subCode, setSubscriberCode] = useState<string>('');
  const [subscriberCodeError, setSubscriberCodeError] = useState<string>('');

  const isValidSubscriberCode = (): boolean => {
    if (!subCode) {
      if (subscriberCodes.length === 0) {
        setSubscriberCodeError('Please provide a valid subscriber code.');
      } else {
        setSubscriberCodeError('Please select a valid subscriber code.');
      }
    } else if (!subCode?.toString()?.trim()) {
      setSubscriberCodeError(
        'Subscriber code should be a valid 7 digit number',
      );
    } else if (!/^\d{7}$/.test(subCode)) {
      setSubscriberCodeError(
        'Subscriber code should be a number with 7 digits.',
      );
    } else {
      setSubscriberCodeError('');
      return true;
    }
    return false;
  };
  return (
    <Spin
      spinning={isLoading}
      tip=''
      blurContainerProps={isLoading ? { opacity: 0.3 } : {}}
    >
      <VStack justify='center'>
        {errorMsg && (
          <Alert
            description={errorMsg}
            type='error'
            isOpen
            showCloseButton={false}
            showIcon={false}
            mb={2}
            w='fit-content'
          />
        )}
        {showModal && (
          <VStack>
            <HStack justifyContent='center' alignItems='center'>
              {subscriberCodes.length == 0 && (
                <>
                  <Text fontSize='md'>Subscriber Code</Text>
                  <Input
                    name='subscriberCode'
                    w='64'
                    required
                    onChange={(val) => {
                      setSubscriberCode(val.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        isValidSubscriberCode()
                          ? onClick && onClick(subCode)
                          : null;
                      }
                    }}
                    onBlur={isValidSubscriberCode}
                    _focus={{ boxShadow: 'none' }}
                    h={8}
                    spellCheck={false}
                  />
                  <Button
                    colorScheme='blue'
                    size='md'
                    isLoading={isLoading}
                    onClick={() => {
                      isValidSubscriberCode()
                        ? onClick && onClick(subCode)
                        : null;
                    }}
                    h={8}
                  >
                    Search
                  </Button>
                </>
              )}
              {subscriberCodes.length > 1 && (
                <>
                  <Text fontSize='md'>Subscriber Code</Text>
                  <Select
                    placeholder='Select Subscriber Code'
                    options={subscriberCodes.map((subcode) => ({
                      label: subcode,
                      value: subcode,
                    }))}
                    optionLabelProps={{ color: 'black' }}
                    selectContainerProps={{ width: 250 }}
                    onChange={(val) => {
                      setSubscriberCode(val as string);
                    }}
                  />
                  <Button
                    colorScheme='blue'
                    size='md'
                    isLoading={isLoading}
                    onClick={() => {
                      isValidSubscriberCode()
                        ? onClick && onClick(subCode)
                        : null;
                    }}
                    h={8}
                  >
                    Search
                  </Button>
                </>
              )}
            </HStack>
            <Text color='red.500' textAlign='center'>
              {subscriberCodeError}
            </Text>
          </VStack>
        )}
      </VStack>
    </Spin>
  );
};
